import { I18nId } from '@/i18n/config'
import {
  CollaborativeItemType,
  collaborativeItemTypeSchema,
} from '@/types/schema/collaborative-item'

const getCooperationItemI18nKey = (type: CollaborativeItemType): I18nId => {
  switch (type) {
    case collaborativeItemTypeSchema.enum.live:
      return 'general:cooperation_item_type_live'
    case collaborativeItemTypeSchema.enum.post:
      return 'general:cooperation_item_type_post'
    case collaborativeItemTypeSchema.enum.reels:
      return 'general:cooperation_item_type_reels'
    case collaborativeItemTypeSchema.enum.shorts:
      return 'general:cooperation_item_type_short'
    case collaborativeItemTypeSchema.enum.story:
      return 'general:cooperation_item_type_story'
    case collaborativeItemTypeSchema.enum.video:
      return 'general:cooperation_item_type_video'
    case collaborativeItemTypeSchema.enum.ad_authorization:
      return 'general:cooperation_item_type_ad_authorization'
    case collaborativeItemTypeSchema.enum.material_authorization:
      return 'general:cooperation_item_type_material_authorization'
  }
}

export default getCooperationItemI18nKey
